/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject()
export class MemberContactsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected memberId!: string;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    protected async activate(params: { memberId: string }): Promise<void> {
        if(this.memberId !== params.memberId) { this.memberId = params.memberId; }
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////


}
